import isTemplateTypologyAccessible from './isTemplateTypologyAccessible';
import groupJourneyStepsByChapter from './groupJourneyStepsByChapter';
import isChapter from './isChapter';

const defaultOptions = {
  includeNotVisible: false,
  includeNotAccessible: false,
};

export default function getSortedSteps(steps, {
  includeNotVisible = defaultOptions.includeNotVisible,
  includeNotAccessible = defaultOptions.includeNotAccessible,
} = defaultOptions) {
  return groupJourneyStepsByChapter(steps)
    .map(chapterOrStep => isChapter(chapterOrStep) ? chapterOrStep.steps : chapterOrStep)
    .flat(1)
    .filter(step => (
      includeNotVisible ? true : step.journeyStepPivot.visible
    )).filter(step => (
      includeNotAccessible ? true : isTemplateTypologyAccessible(step.typology)
    ))
}
